var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath76(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.681,
    height: 172.173,
    viewBox: "0 0 147.681 172.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1599.49,555.592h-96.763a25.456,25.456,0,0,0-25.459,25.459V707.036a5.011,5.011,0,0,0,1.2,3.247l13.482,15.74a4.981,4.981,0,0,0,7.569,0l10.9-12.729a4.959,4.959,0,0,1,7.548,0l10.9,12.729a4.981,4.981,0,0,0,7.569,0l10.88-12.729a4.981,4.981,0,0,1,7.569,0l10.9,12.729a4.958,4.958,0,0,0,7.547,0l10.9-12.729a4.982,4.982,0,0,1,7.57,0l10.9,12.729a4.958,4.958,0,0,0,7.547,0l13.5-15.74a4.99,4.99,0,0,0,1.182-3.247V581.051a25.456,25.456,0,0,0-25.459-25.459m-90.1,21.03a16.589,16.589,0,1,1-16.579,16.578,16.573,16.573,0,0,1,16.579-16.578m66.276,91.462h-82.855V655.413h82.855Zm0-22.714h-82.855V632.7h82.855ZM1599.06,602.9a6.456,6.456,0,0,1-6.451,6.451h-51.628a6.47,6.47,0,0,1-6.451-6.451V583.524a6.456,6.456,0,0,1,6.451-6.451h51.628a6.443,6.443,0,0,1,6.451,6.451Z",
    transform: "translate(-1477.268 -555.592)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath76);
export default __webpack_public_path__ + "static/media/Path 76.c1c72c5d207dce4637decb804322b39e.svg";
export { ForwardRef as ReactComponent };